import { Helmet } from "react-helmet-async";

export const SITE = "https://scambiamocelo.it";
export const DEFAULT_OG = "https://static.prod-images.emergentagent.com/jobs/e937dac3-fb33-4fa4-a9d3-ccebcac33546/images/ff29385540be8acce3751bc39a895be622fb5f58c28030bd2f32b2ddd0915c61.jpeg";

export default function Seo({ title, description, path = "", image, noindex = false, type = "website", jsonLd }) {
  const url = SITE + (path || "");
  const img = image || DEFAULT_OG;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content={type} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
